import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../common'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.App.Page.Input,
    graphql.schema.AppPageInput
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    display: graphql.transformers.IN.object<
      ents.core.admin.App.Page.DisplayInfo,
      graphql.schema.AppPageDisplayInput
    >({
      isMain: transformers.PASS_THROUGH,
      position: transformers.PASS_THROUGH,
    }),
    name: transformers.PASS_THROUGH,
    page: graphql.transformers.IN.nonNull(
      common.gql.flexibleIdentifier.inputs.TRANSFORMER,
    ),
    variables: common.gql.dms.data.inputs.variableValue.TRANSFORMER,
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    Partial<ents.core.admin.App.Page.Updates>,
    graphql.schema.AppPageUpdates
  >({
    alias: {
      usingFullInput: graphql.transformers.IN.nonNull(
        graphql.transformers.IN.select(
          'alias',
          graphql.transformers.IN.if(
            TypeChecker.Factory.exact(''),
            graphql.transformers.IN.always(undefined),
            transformers.PASS_THROUGH,
          ),
        ),
      ),
    },
    description: transformers.PASS_THROUGH,
    display: graphql.transformers.IN.nullable(
      graphql.transformers.IN.object<
        ents.core.admin.App.Page.DisplayInfo,
        graphql.schema.AppPageDisplayInput
      >({
        isMain: transformers.PASS_THROUGH,
        position: transformers.PASS_THROUGH,
      }),
    ),
    name: {
      usingFullInput: graphql.transformers.IN.nonNull(
        graphql.transformers.IN.select(
          'name',
          graphql.transformers.IN.if(
            TypeChecker.Factory.exact(''),
            graphql.transformers.IN.always(undefined),
            transformers.PASS_THROUGH,
          ),
        ),
      ),
    },
    page: graphql.transformers.IN.validate(
      common.gql.flexibleIdentifier.inputs.TRANSFORMER,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
    variables: common.gql.dms.data.inputs.variableValue.TRANSFORMER,
  }),
)
